import { LazyLoad } from 'features/common/ui/LazyLoad'
import AuthenticatedRoute from 'app/ui/AuthenticatedRoute'
import GettingStarted from './GettingStarted'

const routes = {
  path: '/sf/getting-started',
  element: (
    <LazyLoad>
      <AuthenticatedRoute element={<GettingStarted />} />
    </LazyLoad>
  )
}

export default routes
